import { Caption as MobileCaption } from '@teko/ds-mobile';
import { Caption as DesktopCaption } from '@teko/ds-desktop';

interface AvailableLeftProps {
  displayTotalAvailable: string;
  isMobile?: boolean;
}

export const AvailableLeft = ({
  displayTotalAvailable,
  isMobile = false,
}: AvailableLeftProps) => {
  return isMobile ? (
    <MobileCaption level={1} color="warning">
      {displayTotalAvailable}
    </MobileCaption>
  ) : (
    <DesktopCaption level={1} color="warning">
      {displayTotalAvailable}
    </DesktopCaption>
  );
};
